import React, { useState } from "react";
import axiosClient from "./axiosClient";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { EyeIcon } from "../utils/validations";
import Popup from "../components/Popup";
const Login = () => {
	const [mobile, setMobile] = useState("");
	const [password, setPassword] = useState("");
	const [errors, setErrors] = useState({});
	const [showPassword, setShowPassword] = useState(false);
	const [rememberMe, setRememberMe] = useState(false);
	const [loading, setLoading] = useState(false);
	const [alert, setAlert] = useState(null);

	const navigate = useNavigate();

	const validator = () => {
		const errs = {};
		if (!mobile.trim()) errs.mobile = "Mobile is required";
		if (!password) errs.password = "Password is required";
		return errs;
	};

	const handelLogin = async (e) => {
		e.preventDefault();

		const validateErrors = validator();
		setErrors(validateErrors);
		if (Object.keys(validateErrors).length > 0) return;

		try {
			setLoading(true);

			const { data } = await axiosClient.post(
				"/auth/login.php",
				{ mobile, password, remember: rememberMe },
				{
					headers: { "Content-Type": "application/json" },
					withCredentials: true, // IMPORTANT for cookie auth
				}
			);

			if (data.status === "success") {
				setAlert({ type: "success", message: data.message });
				const role = data.userRole;
				if (role === "barber" || role === "admin") {
					window.location.href = "/dashboard";
				} else {
					window.location.href = "/view-barbers";
				}
			} else {
				setAlert({ type: "error", message: data.message });
			}
		} catch (error) {
			console.error(error);
			setAlert({ type: "error", message: error?.response?.data?.message || "Server error. Please try again." });
		} finally {
			setLoading(false);
		}
	};

	const handelNavigation = async (e) => {
		e.preventDefault();
		if (!mobile.trim()) {
			setAlert({ type: "error", message: "Enter mobile number first" });
			return;
		}

		try {
			const { data } = await axiosClient.post(
				"/auth/send-otp.php",
				{ mobile },
				{
					headers: { "Content-Type": "application/json" },
				}
			);

			if (data.status === "success") {
				navigate("/forgot-password", { state: { mobile } });
			} else {
				setAlert({ type: "error", message: data.message });
			}
		} catch (error) {
			setAlert({ type: "error", message: "Failed to send OTP" });
		}
	};

	return (
		<div className="login-container">
			{alert && <Popup type={alert.type} message={alert.message} />}
			{/* Right Section */}
			<div className="right-section">
				<div className="hanging-text">
					{"LOGIN".split("").map((char, i) => (
						<span key={i} className={i === 1 ? "swing-o" : ""} >{char}</span>
					))}
				</div>
			</div>

			{/* Left Section */}
			<div className="left-section">
				<h2>Welcome Back</h2>
				<p>Please login to continue</p>

				<form onSubmit={handelLogin} noValidate>
					<input
						type="tel"
						inputMode="numeric"
						value={mobile}
						onChange={(e) => setMobile(e.target.value)}
						placeholder="Mobile number"
						className="input-field"
						autoComplete="username"
					/>
					{errors.mobile && (
						<span style={{ color: "red", fontSize: "14px" }}>
							{errors.mobile}
						</span>
					)}

					<div className="group-input">
						<div style={{ textAlign: "right", marginBottom: "6px", fontSize: "13px" }}>
							<Link style={{ color:'blueviolet'}} to="#" onClick={handelNavigation} className="forgot-link">
								Forgot password?
							</Link>
						</div>
						<div style={{ position: "relative" }}>
							<input
								type={showPassword ? "text" : "password"}
								name="password"
								placeholder="Enter your password"
								className="input-field"
								value={password}
								autoComplete="current-password"
								onChange={(e) => setPassword(e.target.value)}
							/>
							<span
								className="toggelBtn"
								onClick={() => setShowPassword(!showPassword)}
							>
								<EyeIcon visible={showPassword} />
							</span>
						</div>

						{errors.password && (
							<div style={{ color: "red", fontSize: "14px" }}>
								{errors.password}
							</div>
						)}
					</div>

					<div className="bottom-section" style={{ fontSize: "13px", lineHeight: "2" }}>
						<div className="forget">
							<span className="terms-text">
								By continuing, you agree to our{" "}
								<Link style={{color:'blueviolet'}} to="/privacy-policy">Privacy Policy</Link> and{" "}
								<Link style={{color:'blueviolet'}} to="/terms-conditions">Terms & Conditions</Link>
							</span>
						</div>

						<div className="not-member">
							<span>Not a member? </span>
							<Link to="/" style={{ textAlign: "right", color:'blueviolet'}}>Create New account</Link>
						</div>
					</div>

					<button type="submit" className="btn" disabled={loading}>
						{loading ? "Logging in..." : "Login"}
					</button>
				</form>
			</div>
		</div>
	);
};

export default Login;